import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { sanitizeDisplayMessage } from 'src/app/shared/utils/http-error-message';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  constructor() { }

  sweetAlert(icon: any, text: string) {
    const title =
      icon === 'error' ? sanitizeDisplayMessage(text) : text;

    var Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000
    });

    Toast.fire({
      icon: icon,
      title: title,
    })
  }

  async confirm(text: string, title = 'Are you sure?'): Promise<boolean> {
    const result = await Swal.fire({
      icon: 'warning',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#114D84',
    });
    return result.isConfirmed;
  }

  async sweetAlertGift(text1: string, text2: string) {
  const bodyClass = document.body.className;

  let textColor = '#000';
  let redColor = 'red';
  let greenColor = 'green';
  let bgColor = '#fff';

  if (bodyClass.includes('theme-dark')) {
    textColor = '#fff';
    redColor = '#ff6b6b';
    greenColor = '#32cd32';
    bgColor = '#fff';
  }
  if (bodyClass.includes('theme-yellow')) {
  textColor = '#000';
  redColor = 'red';
  greenColor = 'green';
   bgColor = '#fff';
  }

    const container = document.createElement('div');
    container.style.cssText = 'display:flex; flex-direction:column; gap:10px;';

    container.appendChild(this.createGiftRow('✗', redColor, textColor, text1));
    container.appendChild(this.createGiftRow('✓', greenColor, textColor, text2));

    await Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 60000,
      background: bgColor,
      color: textColor,
      html: container,
    } as any);
  }

  private createGiftRow(
    iconText: string,
    iconColor: string,
    textColor: string,
    message: string
  ): HTMLElement {
    const row = document.createElement('div');
    row.style.cssText =
      'display:flex; align-items:center; background:#fff; padding:5px 10px; border-radius:8px;';

    const icon = document.createElement('b');
    icon.style.display = 'inline-block';
    icon.style.width = '24px';
    icon.style.height = '24px';
    icon.style.textAlign = 'center';
    icon.style.lineHeight = '24px';
    icon.style.color = iconColor;
    icon.style.border = '2px solid ' + iconColor;
    icon.style.borderRadius = '50%';
    icon.textContent = iconText;

    const span = document.createElement('span');
    span.style.marginLeft = '8px';
    span.style.color = textColor;
    span.textContent = message;

    row.appendChild(icon);
    row.appendChild(span);
    return row;
  }
}
